import { formatPrice } from '@lib/utils';
import { defaultTheme } from '@lib/themes';
import { ItemWrapper } from './style';
import Typography from '../../Typography';

import type { PercentageInfo } from '../types';
import type React from 'react';

export const Item: React.FC<PercentageInfo> = ({ label, value }) => (
  <ItemWrapper>
    <Typography className="label" type="B2">
      {label}
    </Typography>
    <Typography
      className="value"
      type="B2"
      style={{ color: value < 0 ? defaultTheme.colors.red._500 : defaultTheme.colors.green._600 }}
    >
      {`${value > 0 ? '+' : ''}` + formatPrice(value, 2, 'percent', (v) => v)}
    </Typography>
  </ItemWrapper>
);
